"use strict";

exports.__esModule = true;
exports.ClockElement = ClockElement;
var _react = _interopRequireDefault(require("react"));
var _MeasurementValue = require("../../Measures/MeasurementValue");
var _Time = require("../../Time");
var _common = require("../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays a label for a section.
 */
function ClockElement(props) {
  var format = props.timeFormat || {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  };
  var locales = format != null && format.hasOwnProperty("hour11") ? "en-US" : undefined;
  return /*#__PURE__*/_react["default"].createElement(_Time.TimeContext.Consumer, null, function (_ref) {
    var timezone = _ref.timezone;
    return /*#__PURE__*/_react["default"].createElement(_Time.CurrentPlantTime, {
      frequency: 4
    }, function (date) {
      return /*#__PURE__*/_react["default"].createElement(_MeasurementValue.MeasurementValue, _extends({
        value: date.toLocaleTimeString(locales, format),
        units: "",
        label: props.showTimezone ? timezone.name : "",
        color: props.color,
        backgroundColor: props.backgroundColor
      }, (0, _common.getWidgetPositionProps)(props), (0, _common.getWidgetFontProps)(props), (0, _common.getWidgetInteractionProps)(props)));
    });
  });
}